import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Users, Calendar, Sparkles, Wallet } from "lucide-react";

export const SearchBar = ({ variant = "hero" }) => {
    const nav = useNavigate();
    const [destination, setDestination] = useState("");
    const [days, setDays] = useState(5);
    const [travelers, setTravelers] = useState(2);
    const [budget, setBudget] = useState("mid");

    const submit = (e) => {
        e.preventDefault();
        if (!destination.trim()) return;
        const q = new URLSearchParams({
            destination: destination.trim(),
            days: String(days),
            travelers: String(travelers),
            budget_level: budget,
        }).toString();
        nav(`/explore?${q}`);
    };

    const isHero = variant === "hero";

    return (
        <form
            onSubmit={submit}
            data-testid="search-form"
            className={`glass ${isHero ? "rounded-3xl p-3 md:p-4" : "rounded-2xl p-2 md:p-3"} grid w-full grid-cols-1 gap-2 md:grid-cols-[1.6fr_0.9fr_0.9fr_0.9fr_auto]`}
        >
            <label className="group flex items-center gap-2 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-jade/10 focus-within:ring-terracotta/40 transition">
                <MapPin size={18} className="text-terracotta" />
                <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-moss/70">Where</div>
                    <input
                        data-testid="search-destination"
                        value={destination}
                        onChange={(e) => setDestination(e.target.value)}
                        placeholder="Bali, Lisbon, Kyoto…"
                        className="w-full bg-transparent text-ink placeholder:text-moss/40 outline-none"
                    />
                </div>
            </label>

            <label className="group flex items-center gap-2 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-jade/10 focus-within:ring-terracotta/40 transition">
                <Calendar size={18} className="text-jade" />
                <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-moss/70">Days</div>
                    <input
                        data-testid="search-days"
                        type="number"
                        min="1"
                        max="60"
                        value={days}
                        onChange={(e) => setDays(Number(e.target.value || 1))}
                        className="w-full bg-transparent text-ink outline-none"
                    />
                </div>
            </label>

            <label className="group flex items-center gap-2 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-jade/10 focus-within:ring-terracotta/40 transition">
                <Users size={18} className="text-jade" />
                <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-moss/70">Travelers</div>
                    <input
                        data-testid="search-travelers"
                        type="number"
                        min="1"
                        max="20"
                        value={travelers}
                        onChange={(e) => setTravelers(Number(e.target.value || 1))}
                        className="w-full bg-transparent text-ink outline-none"
                    />
                </div>
            </label>

            <label className="group flex items-center gap-2 rounded-2xl bg-white/60 px-4 py-3 ring-1 ring-jade/10 focus-within:ring-terracotta/40 transition">
                <Wallet size={18} className="text-jade" />
                <div className="flex-1">
                    <div className="text-[10px] uppercase tracking-[0.18em] text-moss/70">Budget</div>
                    <select
                        data-testid="search-budget"
                        value={budget}
                        onChange={(e) => setBudget(e.target.value)}
                        className="w-full bg-transparent text-ink outline-none"
                    >
                        <option value="budget">Budget</option>
                        <option value="mid">Mid-range</option>
                        <option value="luxury">Luxury</option>
                    </select>
                </div>
            </label>

            <button
                type="submit"
                data-testid="search-submit"
                className="btn-primary justify-center rounded-2xl !px-6 !py-4"
            >
                <Sparkles size={16} className="mr-2" /> Find trip
            </button>
        </form>
    );
};

export default SearchBar;
